class ClientController {

    constructor(
        $uibModal,
        CommonRequest
    ){
        'ngInject';
        this.$uibModal = $uibModal;
        this.CommonRequest = CommonRequest;
    }

    $onInit() {
        this.isEditMode = false;
        this.surveyStatus = this.client.can_create_surveys ? 'On': 'Off';
    }

    /***
     * Calls the callback function to "delete" this Client.
     *
     * NOTE: all deletes are soft deletes and are actually only deactivated in the database.
     */
    deleteClient() {
        const newStatusVerb = this.client.is_active ? 'delete' : 'reactivate';
        const doDelete = confirm(`Are you sure you want to ${newStatusVerb} client ${this.client.name}?`);
        if (doDelete) {
            this.onDelete({client: this.client});
        }
    }

    /***
     * Switches the current Client from a display mode where its values are static to an editable
     * mode where they are forms that the user can update.
     */
    startEditMode() {
        this.isEditMode = true;
    }

    /***
     * Listens for an escape key press and switches the Client from edit mode to display mode.
     *
     * @param event     the keyup event
     */
    stopEditMode(event) {
        if (event.keyCode === 27) {
            this.isEditMode = false;
            this.client.name = this.client.displayName;
            this.client.site_id = this.client.displaySiteID;
        }
    }

    /***
     * Calls the callback function to update this Client with its updated name. Only calls the
     * function if the name has actually been changed.
     */
    updateClient() {
        if (this.client.name.length > 0) {
            this.onUpdate({client: this.client,
                           updatedName: this.client.name,
                           updatedSiteID: this.client.site_id}).then((response) => {
                if (response.status >= 200 && response.status <= 300) {
                    this.isEditMode = false;
                }
            })
        }

    }

}

export default ClientController;



// WEBPACK FOOTER //
// ./app/components/client-admin/client/client-controller.js